import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_branch",
  "use": "icon-project_branch-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_branch\"><g transform=\"translate(1 3)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\"><rect x=\"9\" y=\"1\" width=\"8\" height=\"6\" rx=\"2\" /><rect x=\"1\" y=\"15\" width=\"8\" height=\"6\" rx=\"2\" /><rect x=\"17\" y=\"15\" width=\"8\" height=\"6\" rx=\"2\" /><path stroke-linejoin=\"round\" d=\"M5 15.14v-4h16v4\" /><path stroke-linecap=\"square\" d=\"M13 8v3\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol